module.exports = __webpack_public_path__ + "static/media/arrow-down.7631ee3f.svg";